module.exports = __webpack_public_path__ + "static/media/ct1_4min-min.4f74acb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/create-tracks/coke/ct1_4min-min.jpg
// module id = 257
// module chunks = 0